// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"AdminProvisionsView-module__badgeWrapper--0+0wa","addNewWrapper":"AdminProvisionsView-module__addNewWrapper--2Ztmw"};